export default __webpack_public_path__ + "static/spacerowebingo-a25272c0481912aea5144f3bb5d27335.jpg";